import { createFileRoute } from '@tanstack/react-router'
import { useMyAssessments } from '@/features/assessments/services/assessments.convex'
import { AssessmentsTable } from '@/features/assessments/components/AssessmentsTable'
import { useMyConvexUserId } from '@/features/auth'

export const Route = createFileRoute('/(dashboard)/assessments/')({
  component: PersonalAssessmentsPage,
  validateSearch: () => ({}), // Clear any search params from previous routes
  beforeLoad: () => ({
    title: 'Assessments',
  }),
})

function PersonalAssessmentsPage() {
  const convexUserId = useMyConvexUserId()
  const { results, status, loadMore } = useMyAssessments()

  const isLoading = status === 'LoadingFirstPage'
  const hasMore = status === 'CanLoadMore'
  const isLoadingMore = status === 'LoadingMore'

  return (
    <AssessmentsTable
      assessments={results}
      currentUserId={convexUserId ?? ''}
      isLoading={isLoading}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={() => loadMore(10)}
      isDirectReportsView={false}
    />
  )
}
